const phoneProTechValidation = (phone) => {
  const phoneValid = /^\d{3}-\d{3}-\d{4}$/;
  return phoneValid.test(phone);
};

export default phoneProTechValidation;
